import { Configuration } from '@spotify-internal/remote-config-resolver';
import { createContext, useContext } from 'react';
import {
  properties,
  MrktWebBoolRCPropertySpecs,
  MrktWebEnumRCPropertySpecs,
  MrktWebIntRCPropertySpecs,
} from './properties';

// default config uses default values
const defaultConfig = Configuration.withOverride(properties, {});

const Context = createContext<Configuration>(defaultConfig);

export const RemoteConfigProvider = Context.Provider;

function useConfig(): Configuration {
  const config = useContext(Context);
  if (!config.isActive) throw config.activationPromise; // suspend if not active
  return config;
}

// We use a defaulted generic (`Spec = MrktWebIntRCPropertySpecs`) only to allow
// another value to be used during tests.

export function useRemoteInt<
  Spec extends { name: string } = MrktWebIntRCPropertySpecs
>(key: Spec['name']) {
  return useConfig().getInt(key);
}

export function useRemoteBool<
  Spec extends { name: string } = MrktWebBoolRCPropertySpecs
>(key: Spec['name']) {
  return useConfig().getBool(key);
}

export function useRemoteEnum<
  Spec extends { name: string; enumSpec: any } = MrktWebEnumRCPropertySpecs
>(key: Spec['name']) {
  // Have to type hint to the valid string values, otherwise return type will
  // only be "string"
  return useConfig().getEnum(key) as Spec['enumSpec']['values'][number];
}
